// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qr4DB","title":"styles_title__914GE","blogList":"styles_blogList__hdDRv"};